import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { canAccessV2Studio, getV2PublicOrigin } from '../config/domainExperience';

/**
 * Renders Studio V2 when this host may serve it (InterviewFlow, BaigLabs, localhost).
 * Otherwise sends the browser to getV2PublicOrigin() with the same path.
 */
function V2StudioRouteGate({ children }) {
  const [phase, setPhase] = useState(() => (canAccessV2Studio() ? 'ok' : 'check'));

  useEffect(() => {
    if (canAccessV2Studio()) {
      setPhase('ok');
      return;
    }
    const origin = getV2PublicOrigin();
    const url = `${origin}${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.replace(url);
  }, []);

  if (phase === 'ok') {
    return children;
  }

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4, gap: 2,
    }}
    >
      <CircularProgress size={32} />
      <Typography variant="body2" color="text.secondary">
        Opening InterviewFlow Studio…
      </Typography>
    </Box>
  );
}

export default V2StudioRouteGate;
